<template>
  <BaseCustomizeMetal componentCode="A" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalA",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 124px;
    left: 111px;
    @include betweenTableTablePro {
      top: 84px;
      left: 61px;
    }
    @include table {
      top: 64px;
      left: 36px;
    }
    @include phone {
      top: 54px;
      left: 21px;
    }
  }
  .templeName {
    height: 33px;
    width: 235px;
    .textContainer {
      width: 235px;
    }
  }
  .godName {
    width: 279px;
    height: 58px;
    .textContainer {
      width: 279px;
    }
  }
  .gift {
    width: 171px;
    height: 33px;
    .textContainer {
      width: 171px;
    }
  }
}
</style>
